// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 336) return "bundle.css";
	// return url for filenames based on template
	return undefined;
};